import toZeroUTCOnCurrentDay from '@/utils/toZeroUTCOnCurrentDay'

interface Options {
  isLastMillisecondByEnd?: boolean
}

const getUtcStartEndForQuery = (dateRange: Date[], options?: Options) => {
  const [start, end] = dateRange

  const startUTC = start ? toZeroUTCOnCurrentDay(start) : start

  const endUTC = end
    ? toZeroUTCOnCurrentDay(end, { isLastMillisecond: options?.isLastMillisecondByEnd ?? true })
    : end

  return [startUTC, endUTC]
}

export default getUtcStartEndForQuery
